import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import {Box, Button, Container, TextField, Typography} from "@mui/material";
import {resetPassword} from "../api/api";

const ResetPasswordPage = () => {
    const {t} = useTranslation();

    const location = useLocation();
    const navigate = useNavigate();
    const token = location.state?.resetSessionToken;

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const handleReset = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");

        try {
            await resetPassword(token, newPassword, confirmPassword);
            setSuccess(true);
        } catch (err: any) {
            setError(err.message ?? t("resetpassword.errors.default"));
        }
    };

    return (
        <Container maxWidth="xs">
            <Box py={10}>
                <Box p={3} boxShadow={3} borderRadius={2}>
                    <Typography variant="h5" align="center" gutterBottom>
                        {t("resetpassword.title")}
                    </Typography>

                    {success && (
                        <>
                            <Typography color="primary" align="center" sx={{mt: 2}}>
                                {t("resetpassword.success")}
                            </Typography>

                            <Button
                                fullWidth
                                variant="contained"
                                sx={{mt: 3}}
                                onClick={() => navigate("/login")}
                            >
                                {t("resetpassword.goToLogin")}
                            </Button>
                        </>
                    )}

                    {!success && error && (
                        <Typography color="error" align="center">
                            {error}
                        </Typography>
                    )}

                    {!success && (
                        <form onSubmit={handleReset}>
                            <TextField
                                fullWidth
                                label={t("resetpassword.newPassword")}
                                type="password"
                                margin="normal"
                                required
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />

                            <TextField
                                fullWidth
                                label={t("resetpassword.confirmPassword")}
                                type="password"
                                margin="normal"
                                required
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />

                            <Button type="submit" fullWidth variant="contained" sx={{mt: 2}}>
                                {t("resetpassword.resetPassword")}
                            </Button>
                        </form>
                    )}
                </Box>
            </Box>
        </Container>
    );
};

export default ResetPasswordPage;